import {
  Alert,
  Button,
  Card,
  CardContent,
  Chip,
  Stack,
  Typography,
} from '@mui/material'

import SaveBackupCodes from '../../components/auth/SaveBackupCodes'
import SecurityIcon from '@mui/icons-material/Security'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import fetchWithAuth from '../../utilities/fetchWithAuth'
import { useState } from 'react'

const BackupCodesCard = ({
  backupCodes,
  setBackupCodes,
  twoFaEnabled,
  backupCodesCount,
}) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [localBackupCodesCount, setLocalBackupCodesCount] =
    useState(backupCodesCount)

  const handleConfirm = () => {
    setIsExpanded(false)
  }

  const handleRegenerate = async () => {
    try {
      const { data } = await fetchWithAuth('auth/2fa/regenerate-backup-codes', {
        method: 'POST',
      })
      setBackupCodes(data.backupCodes)
      setLocalBackupCodesCount(4)
      setIsExpanded(true)
    } catch (error) {
      console.error('Error regenerating backup codes:', error)
    }
  }

  return (
    <Card>
      <CardContent>
        <Stack spacing={2}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6" component="h2" color="primary">
              Two Factor Authentication
            </Typography>
            <Chip
              label={twoFaEnabled ? 'Enabled' : 'Disabled'}
              color={twoFaEnabled ? 'success' : 'default'}
              size="small"
            />
          </Stack>

          {twoFaEnabled && (
            <>
              <Stack direction="row" spacing={1} alignItems="center">
                <WarningAmberIcon color="warning" />
                <Typography variant="body2">
                  You have {localBackupCodesCount ?? backupCodesCount ?? 0} of 4
                  backup codes available.
                </Typography>
              </Stack>

              <Typography variant="body2" color="text.secondary">
                To make sure you continue to have access to your account, always
                have available backup codes. Keep in mind, old backup codes
                become invalid once you generate new ones.
              </Typography>

              {!isExpanded && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleRegenerate}
                  sx={{ alignSelf: 'flex-start' }}
                >
                  Generate New Backup Codes
                </Button>
              )}

              {isExpanded && backupCodes && (
                <SaveBackupCodes
                  onConfirm={handleConfirm}
                  backupCodes={backupCodes}
                />
              )}
            </>
          )}

          {!twoFaEnabled && (
            <Typography variant="body2" color="text.secondary">
              Enable two-factor authentication to use backup codes.
            </Typography>
          )}
        </Stack>
      </CardContent>
    </Card>
  )
}

export default BackupCodesCard
